module.exports = __webpack_public_path__ + "static/media/balmain.cb76e72b.jpg";